import { useEffect, useState } from "react";

const NAV_LINKS = [
  { id: "guatian", label: "今日瓜田" },
  { id: "lanmu", label: "聊点什么" },
  { id: "why", label: "为什么加入" },
  { id: "join", label: "入群指南" },
  { id: "kouping", label: "群友口碑" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0_rgba(0,0,0,0.05)]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between">
          {/* Logo */}
          <a
            href="#top"
            className="flex items-center gap-2 whitespace-nowrap"
            aria-label="九色吃瓜 首页"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-message-3-line text-lg" aria-hidden="true"></i>
            </span>
            <span
              className={`font-heading text-lg font-bold tracking-tight transition-colors ${
                scrolled || open ? "text-foreground-900" : "text-background-50"
              }`}
            >
              九色吃瓜
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {NAV_LINKS.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors hover:bg-background-200/70 ${
                  scrolled ? "text-foreground-700" : "text-background-50/90"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="#joinform"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              加入吃瓜群
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </a>
          </div>

          {/* Hamburger */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden flex h-10 w-10 items-center justify-center rounded-full border transition-colors ${
              open
                ? "border-primary-200 bg-primary-100/70 text-primary-700"
                : scrolled
                  ? "border-background-200 text-foreground-800"
                  : "border-white/40 text-background-50"
            }`}
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <nav
          className="lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur-md px-4 pb-6 pt-3 md:px-6"
          aria-label="移动端导航"
        >
          <ul className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between rounded-lg px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
                >
                  {link.label}
                  <i className="ri-arrow-right-s-line text-lg text-foreground-400" aria-hidden="true"></i>
                </a>
              </li>
            ))}
            <li className="mt-3">
              <a
                href="#joinform"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                加入吃瓜群
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}